export default "__VITE_ASSET__debe4c11__"